// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"select_wrapper__3GH5w","input":"select_input__3ZAip","label":"select_label__264gD","error":"select_error__2B92r"};